import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function TradeSizeDistribution({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    return (
        <ChartSection id="trade-size" title="How much do they spend per trade?" subtitle="Distribution of disclosed trade value brackets. The STOCK Act only requires ranges, not exact amounts.">
            <Box sx={{ height: 300 }}>
                <ResponsiveBar
                    data={data} keys={['count']} indexBy="bracket"
                    margin={{ top: 10, right: 20, bottom: 50, left: 55 }}
                    padding={0.3} borderRadius={3} enableLabel
                    label={d => d.value.toLocaleString()}
                    labelTextColor="#ffffff"
                    colors={[colors.primary]}
                    axisBottom={{ tickRotation: -25 }}
                    axisLeft={{ legend: 'Trades', legendPosition: 'middle', legendOffset: -45 }}
                    tooltip={({ data: d, color }) => (
                        <ChartTooltip
                            title={d.bracket}
                            rows={[{ label: 'Trades', value: d.count.toLocaleString(), color }]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
